import type { Resource } from '../../';
export const footer_emailForm_success: Resource = {"default":"Successfully subscribed!"};
